import {
  createBrowserRouter,
  createRoutesFromElements,
  Route
} from 'react-router';
import ErrorPage from '@/pages/error/ErrorPage.tsx';
import PublicLayout from '@/layouts/PublicLayout.tsx';
import HomePage from '@/pages/home/HomePage.tsx';
import LoginPage from '@/pages/auth/login/LoginPage.tsx';
import AuthLayout from '@/layouts/AuthLayout.tsx';
import AdminLayout from '@/layouts/AdminLayout.tsx';
import AdminPage from '@/pages/admin/AdminPage.tsx';
import Companies from '@/pages/admin/company/Companies.tsx';
import CompanyDetailed from '@/pages/admin/company/CompanyDetailed';

export const routes = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<HomePage />} />
      </Route>
      <Route path="auth" element={<AuthLayout />}>
        <Route path="login" element={<LoginPage />} />
      </Route>

      <Route path="admin" element={<AdminLayout />}>
        <Route index element={<AdminPage />} />
        <Route
          path="company/pending"
          element={<Companies status="pending" />}
        />
        <Route path="company/pending/:id" element={<CompanyDetailed />} />
        <Route path="company/active/:id" element={<CompanyDetailed />} />
        <Route
          path="company/activated"
          element={<Companies status="active" />}
        />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </>
  )
);
